module.exports = __webpack_public_path__ + "static/media/bigX.7e526207.png";